import { render, staticRenderFns } from "./naj-item-description.vue?vue&type=template&id=257d0bbc&scoped=true&"
import script from "./naj-item-description.vue?vue&type=script&lang=js&"
export * from "./naj-item-description.vue?vue&type=script&lang=js&"
import style0 from "./naj-item-description.vue?vue&type=style&index=0&id=257d0bbc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "257d0bbc",
  null
  
)

export default component.exports